import { mgmtAxios } from './mgmt';

export interface CameraErrorPayload {
  err_name?: string;
  err_message?: string;
  user_agent?: string;
  is_in_liff?: boolean;
  step?: number;
  retry_count?: number;
  brand_id?: number;
  page_url?: string;
  referrer?: string;
}

// PG-109 fire-and-forget,失敗一律靜默,絕對不能影響歸還流程
export const logCameraError = (payload: CameraErrorPayload): void => {
  // PG-56 改打新後端(對齊已建的 public/client-log/camera-error)
  mgmtAxios
    .request({
      url: '/api/public/client-log/camera-error',
      method: 'POST',
      data: payload,
      timeout: 5000,
    })
    .catch(() => {
      // 吞掉,觀察用 log 失敗本來就無關緊要
    });
};
